import { forwardRef, type ButtonHTMLAttributes, type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';

export interface ListRowsProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function ListRows({ className, children, ...props }: ListRowsProps) {
  return (
    <div className={cn('list-rows', className)} {...props}>
      {children}
    </div>
  );
}

export interface ListRowProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  children: ReactNode;
}

/** Clickable dense list row (Quick Panel lists + mobile-friendly pickers). */
export const ListRow = forwardRef<HTMLButtonElement, ListRowProps>(function ListRow(
  { selected = false, className, type = 'button', children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn('list-row', selected && 'is-selected', className)}
      {...props}
    >
      {children}
    </button>
  );
});

export interface ListRowMetaProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function ListRowMeta({ className, children, ...props }: ListRowMetaProps) {
  return (
    <span className={cn('list-row-meta', className)} {...props}>
      {children}
    </span>
  );
}

export interface ListRowMainProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function ListRowMain({ className, children, ...props }: ListRowMainProps) {
  return (
    <div className={cn('list-row-main', className)} {...props}>
      {children}
    </div>
  );
}

export interface ListRowTitleProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function ListRowTitle({ className, children, ...props }: ListRowTitleProps) {
  return (
    <div className={cn('list-row-title', className)} {...props}>
      {children}
    </div>
  );
}

export interface ListRowSubtitleProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function ListRowSubtitle({ className, children, ...props }: ListRowSubtitleProps) {
  return (
    <div className={cn('list-row-subtitle', className)} {...props}>
      {children}
    </div>
  );
}

export interface ListRowAsideProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function ListRowAside({ className, children, ...props }: ListRowAsideProps) {
  return (
    <div className={cn('list-row-aside', className)} {...props}>
      {children}
    </div>
  );
}

export interface ListRowAsideValueProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function ListRowAsideValue({ className, children, ...props }: ListRowAsideValueProps) {
  return (
    <span className={cn('list-row-aside-value', className)} {...props}>
      {children}
    </span>
  );
}
